import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { useIsCommunityAdmin } from "@circle-react/contexts/punditUserContext";
import { useShallow } from "zustand/react/shallow";

import { useIsCircleAiPageRoute } from "@/react/components/CircleAi/useIsCircleAiPageRoute";
import { useIsAdminArea } from "@/react/components/SettingsApp/CompassCompat/useIsAdminArea";

interface ConversationPanelToggle {
  isOpen: boolean;
  toggle: () => void;
}

export const useConversationPanelToggle = (): ConversationPanelToggle => {
  const isAdmin = useIsCommunityAdmin();
  const isAdminArea = useIsAdminArea();
  const { isAiRoute } = useIsCircleAiPageRoute();

  const {
    conversationPanelState,
    setConversationPanelState,
    setAdminDockForced,
    setMode,
  } = useCircleAIShellStore(
    useShallow(s => ({
      conversationPanelState: s.conversationPanelState,
      setConversationPanelState: s.setConversationPanelState,
      setAdminDockForced: s.setAdminDockForced,
      setMode: s.setMode,
    })),
  );

  const isOpen = conversationPanelState !== "closed";

  const toggle = () => {
    const willOpen = !isOpen;
    setConversationPanelState(willOpen ? "default" : "closed");
    if (isAdmin) {
      setAdminDockForced(willOpen);
      if (!willOpen && !isAdminArea && !isAiRoute) setMode("community");
    }
  };

  return { isOpen, toggle };
};
